<style lang="scss"></style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 20px;">
    <div ref="titleBar" class="titleBar" style="display: flex;align-items:center ;padding-bottom: 10px;">
      <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
      <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
        {{ $t("xiaolvzhibiao") }}
      </p>
      <div style="margin-left: 18px;">
        <p style="font-size: 12px;line-height: 22px;color: #C0C4CC;">
          {{ $t("统计周期") + " " + zq }}
        </p>
      </div>
    </div>
    <div style="display: flex;justify-content:space-around;align-items: center;" :style="{ height: contentHeight + 'px' }">
      <div style="text-align: center;">
        <p>
          <span style="font-size: 32px;font-weight:bold;color: white;">{{ turnover }}</span><span style="font-size: 18px;color: white;margin-left: 10px;">h</span>
        </p>
        <p style="font-size: 14px;color: white;margin-top: 20px;">
          料车平均周转时间
        </p>
      </div>
      <div style="text-align: center;">
        <p>
          <span style="font-size: 32px;font-weight:bold;color: white;">{{ weight }}</span>
        </p>
        <p style="font-size: 14px;color: white;margin-top: 20px;">
          日平均称重车次
        </p>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_monitor_workshop_oee",
  components: {},

  data() {
    return {
      timmer: null,
      contentHeight: 0,
      turnover: 0,
      weight: 0,
      zq: "",
    };
  },
  watch: {
    "$attrs.orgId"(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.getEfficiencyStatistics();
    },
  },
  created() {
    this.timmer = setInterval(() => {
      this.getEfficiencyStatistics();
    }, 120000);
    setTimeout(() => {
      //等待获取高度再生成,resize是延迟800的，这里1000
      this.getEfficiencyStatistics();
    }, 1000);
  },
  activated() {
    this.resize();
  },
  mounted() {
    setTimeout(() => {
      this.resize();
    }, 700);

    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  destroyed() {
    clearInterval(this.timmer);
  },
  methods: {
    async getEfficiencyStatistics() {
      let response = await this.http.get("/web/slag/collection/record/getAverageTurnoverTime", {
        params: {
          orgId: this.$attrs.orgId,
        },
      });
      this.turnover = response.data;

      let response2 = await this.http.get("/web/slag/collection/record/getDailyAverageWeighingTimes", {
        params: {
          orgId: this.$attrs.orgId,
        },
      });
      this.weight = response2.data;

      let response3 = await this.http.get("/web/slag/collection/record/getDailySlagOutputDistribution", { params: { orgId: this.$attrs.orgId } });
      let t = Object.keys(response3.data)
      t.sort((a, b) => {
        a = this.dayjs(a).valueOf();
        b = this.dayjs(b).valueOf();
        return a - b;
      });

      if (t.length >= 2) {
        this.zq = this.dayjs(t[0]).format("YYYY.MM.DD") + " - " + this.dayjs(t[t.length - 1]).format("YYYY.MM.DD")
      }


      this.resize();
    },
    resize() {
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 20;

        setTimeout(() => {

        }, 0);
      }, 800); //子组件填800，因为父组件500，等父组件调整好高度先
    },

  },
};
</script>
